import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(() => ({
    alertRoot: {
        borderRadius: '10px',
    },
}));
